/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPersonRotation = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M12 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-1 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm-1 4c-.763 0-1.728.352-2.5.97a4.034 4.034 0 0 0-1.22 1.598c.501.703 1.086 1.202 1.72 1.54V13c0-.628.303-1.112.75-1.47a2.65 2.65 0 0 1 .25-.176v1.567l1.698-2.243.425.322H13v1.42l1.318.998.682-.057v-2.122c.1.049.198.106.29.172.368.265.71.715.71 1.589v.251a6.533 6.533 0 0 0 1.985-.646c-.104-1.314-.721-2.237-1.526-2.817A4.35 4.35 0 0 0 14 9zm4.443 9.224.557-.047V22h-2v-1.901z" />
        <path d="m11.659 19.547 3.105-4.035-3.794-2.873-1.208 1.595 1.137.86c-2.254.092-4.641-.705-6.167-3.348l-1.732 1c.836 1.449 1.873 2.463 3 3.144a8.345 8.345 0 0 0 3.314 1.128c.579.073 1.155.091 1.716.067l-.956 1.242zM11 20.806V22H9v-2.733zm5-6.139a8.396 8.396 0 0 0 2-.527 6.554 6.554 0 0 0 1.899-1.165l1.33 1.494c-1.654 1.47-3.728 2.094-5.582 2.25l-.167-1.994c.173-.014.346-.034.52-.058z" />
      </g>
    </g>
  </Icon>
);
export { SvgPersonRotation as PersonRotation };
